import React, { FC } from 'react';
import {
  FormItemQccHonorQualificationDetailList,
  FormModule,
} from '@purchase/supplier';

export interface QccHonorListProps {
  count: number;
}

export const QccHonorList: FC<QccHonorListProps> = ({ count }) => {
  return (
    <FormModule
      title="企业荣誉"
      titleCount={count}
      proCardProps={{ expandable: true, defaultExpanded: count > 0 }}
      skipAnchorCollect
    >
      <FormItemQccHonorQualificationDetailList
        name="vendorQccHonorQualifications"
        fieldProps={{ scroll: { x: 1500 } }}
      />
    </FormModule>
  );
};
